import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Tabs,
  Tab,
  Avatar,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation, useParams } from "react-router-dom";

import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import sitesIcon from "../../assets/images/icon/sites.svg";
import editIcon from "../../assets/images/edit.svg";
import ProfileIn from "../../assets/images/prop.jpg";

import eyeIcon from "../../assets/images/icon/eye.png";
import threeDotsIcon from "../../assets/images/icon/threedots.png";
import licensesIcon from "../../assets/images/icon/licenses.svg";
import userIcon from "../../assets/images/icon/User.svg"
import merIcon from "../../assets/images/mrt.svg";

import customersIcon from "../../assets/images/icon/customers.svg";
import homeIcon from "../../assets/images/icon/home.svg";
import { getMethod } from "../../services/apiService";
import { Image } from "react-bootstrap";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import CustomerLicenseTab from "./customerLicenseTab";
import CustomerSitesDevicesTab from "./customerSitesDevicesTab";
import { idText } from "typescript";
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../services/placeService";
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { TextField as formikTextField } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError, mixed } from 'yup';
import { putFormMethod, postMethodFormData } from "../../services/apiService";
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from 'react-router-dom';
import { ToastContext, useToastContext } from "../../context/toastContext";
import { Form as RBFORM } from 'react-bootstrap';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import noteIcon from '../../assets/images/noteIcon.svg';
import { allTimezones  } from "react-timezone-select";

const CustomerDetails = () => {
  const [open, setOpen] = useState(false);
  const { setToast } = useToastContext() as ToastContext;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();


  useEffect(() => {
    fetchCustomerList();
    getCountryList();
    getStateList();
    getCityList();
  }, []);

  const [customerData, setCustomerData] = useState<any>([]);

  const fetchCustomerList = async () => {
    const resp = await getMethod(`customer/${id}`);
    if (resp?.data?.code === 200) {
      setCustomerData(resp?.data?.result);
    } else {
      setCustomerData([]);
    }
  };

  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  let { id, companyName } = useParams();

  const [customerTable, setCustomerTableData] = useState<any>([]);

  const fetchCustomerTableData = async () => {


    setCustomerTableData([]);
    let endpoint = "";
    if (activeTab) {
      endpoint = `customer/site/enterpriseid/${id}`
    } else {
      endpoint = `customer/order/enterpriseid/details/${id}`
    }

    const resp = await getMethod(

      endpoint
    );
    if (resp?.data?.code === 200) {
      setCustomerTableData(resp?.data?.result);
    } else {
      setCustomerTableData([]);
    }
  };

  useEffect(() => {
    fetchCustomerTableData();
  }, [activeTab]);

  const breadCrumb = [{
    label: "Home",
    path: '/customer/overview'
  },
  {
    label: companyName,
    path: `/customer/details/${companyName}/${id}`
  },
  ]

  const [addSiteModalOpen, setAddSiteModalOpen] = useState(false);
  const [siteEdit, setSiteEdit] = useState(false);
  const [siteId, setSiteId] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState("");
  const [stateList, setStateList] = useState([]);
  const [filteredStateList, setFilteredStateList] = useState([]);
  const [state, setState] = useState("");
  const [cityList, setCityList] = useState([]);
  const [filteredCityList, setFilteredCityList] = useState([]);
  const [city, setCity] = useState("");
  const [customerTimeZone, setCustomerTimeZone] = useState("");


  const [siteInitialValues, setSiteInitialValues] = useState({
    enterpriseid: id,
    name: '',
    uniqueid: '',
    email: '',
    type: 'EDGE',
    addressline1: '',
    addressline2: '',
    postalcode: '',
    city: '',
    state: '',
    country: '',
    number: '',
    mobile: '',
    redirecturl: '/auth/set-password?uk=',
    timezone: '',
  });


  const getCountryList = async () => {
    const resp = await getCountriesAPI();
    setCountryList(resp.countries);
  }


  const getStateList = async () => {
    const resp = await getStatesAPI();
    setStateList(resp.states);
  }


  const getCityList = async () => {
    const resp = await getCitiesAPI();
    setCityList(resp.cities);
  }


  const handleCountryChange = async (e: any, setFieldValue: any) => {
    const selectedCountryId = e.target.value;
    const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
    setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
    setFieldValue("country", selectedCountry.id.toString());

    setTimeout(() => {
      const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
      setFilteredStateList(filteredStates);
    }, 200);
  }


  const handleStateChange = async (e: any, setFieldValue: any) => {
    const selectedStateId = e.target.value;
    const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
    setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
    setFieldValue("state", selectedState.id.toString());

    setTimeout(() => {
      const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
      setFilteredCityList(filteredCities);
    }, 200);
  }


  const handleCityChange = async (e: any, setFieldValue: any) => {
    const selectedCityId = e.target.value;
    const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
    setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
    setFieldValue("city", selectedCity.id.toString());
  }


  function getTimezoneOffset(zone: string) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    const parts = formatter.formatToParts(now);
    const localHour = Number(parts.find((p) => p.type === "hour")?.value);
    const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

    const utcHour = now.getUTCHours();
    const utcMinute = now.getUTCMinutes();

    const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
    return totalMinutes;
  }


  const handleTimeZoneChange = async (e: any, setFieldValue: any) => {
    setCustomerTimeZone(e.target.value);
    setFieldValue("timezone", e.target.value);
  }



  function formatOffset(minutes: number) {
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, "0");
    const mins = String(abs % 60).padStart(2, "0");
    return `UTC${sign}${hours}:${mins}`;
  }


  const timezoneList = Object.keys(allTimezones).map((zone) => {
    const offsetInMinutes = getTimezoneOffset(zone);
    const formatted = formatOffset(offsetInMinutes);

    return {
      label: `(${formatted}) ${zone}`,
      value: zone,
    };
  });


  const handleAddSiteModalOpen = async (customer: any, action: string) => {
    setCustomerTimeZone("");
    if (action === "edit") {
      //setCustomerEnterpriseId(customer?.vSite?.enterpriseid);
      setSiteId(customer?.vSite?.siteId);
      setSiteEdit(true);
      let country_id = "";
      if (customer?.vSite?.address?.country !== "") {
        country_id = await getCountryId(customer?.vSite?.address?.country);
      }

      let state_id = "";
      if (customer?.vSite?.address?.state !== "" && country_id != "") {
        state_id = await getStateId(customer?.vSite?.address?.state, country_id.toString());
      }

      let city_id = "";
      if (customer?.vSite?.address?.city !== "" && state_id != "") {
        city_id = await getCityId(customer?.vSite?.address?.city, state_id.toString());
      }
      setSiteInitialValues(prvData => ({
        ...prvData,
        enterpriseid: customer?.vSite?.enterpriseId,
        partnerid: customer?.vCentralUsers?.[0]?.userId,
        name: customer?.vSite?.name,
        uniqueid: customer?.vSite?.deviceid,
        email: customer?.vSite?.contact?.email?.[0]?.id,
        type: customer?.vSite?.type,
        addressline1: customer?.vSite?.address?.addressline1,
        addressline2: customer?.vSite?.address?.addressline2,
        postalcode: customer?.vSite?.address?.postalcode,
        city: city_id,
        state: state_id,
        country: country_id,
        number: customer?.vEnterprise?.contact?.phone?.number || '',
        mobile: customer?.vEnterprise?.contact?.mobile?.[0]?.number || '',
        timezone: customer?.timezone || '',
      }));
    } else {
      if(customer?.timezone) {
        setCustomerTimeZone(customer?.timezone);
        setSiteInitialValues(prvdata => ({
          ...prvdata, enterpriseid: customer?.enterpriseid, timezone: customer?.timezone
        }));
      }      
      setSiteEdit(false);
    }
    setAddSiteModalOpen(true);
  }


  const getCountryId = async (country_name: string) => {
    const country: any = countryList.find((country: any) => country.name === country_name);
    if (country !== undefined) {
      setCountry(country.name);
      return country.id;
    }
    else return "";
  }

  const getStateId = async (state_name: string, country_id: string) => {
    const f_statelist = stateList?.filter((item: any) => item.country_id === country_id);
    setFilteredStateList(f_statelist);
    const state: any = f_statelist.find((state: any) => state.name === state_name && state.country_id === country_id);
    if (state !== undefined) {
      setState(state.name);
      return state.id;
    }
    else return "";
  }

  const getCityId = async (city_name: string, state_id: string) => {
    const f_citylist = cityList?.filter((item: any) => item.state_id === state_id);
    setFilteredCityList(f_citylist);
    const city: any = cityList.find((city: any) => city.name === city_name && city.state_id === state_id);
    if (city !== undefined) {
      setCity(city.name);
      return city.id;
    }
    else return "";
  }

  const handleAddSiteModalClose = () => {
    setCustomerTimeZone("");
    setAddSiteModalOpen(false);
  }

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Header title="" breadCrumb={breadCrumb} />
        <LeftSidebar />

        {/* Main Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: 8,
            padding: "0",
          }}
        >
          <Typography>
            <Box
              p={3}
              sx={{
                backgroundColor: "#03171F",
                color: "#ffffff",
                minHeight: "100vh",
              }}
            >
              {/* Summary Section */}

              <Grid
                container
                spacing={2}
                mb={2}
                sx={{
                  display: "flex",
                  flexFlow: "nowrap",
                }}
              >
                <Card
                  sx={{
                    backgroundColor: "#1e222b",
                    width: "100%",
                  }}
                >
                  <Grid
                    container
                    spacing={2}
                    mb={2}
                    sx={{
                      display: "flex",
                      flexFlow: "nowrap",
                      backgroundColor: "#192529",
                      margin: "0",
                      padding: "25px 20px 20px 20px",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#E2E3E3",
                        fontSize: "16px",
                        fontWeight: "500",
                        display: "flex",
                        alignItems: "center",
                        gridGap: "8px",
                      }}
                    >
                      <img src={customerData?.[0]?.vEnterprise?.logourl} alt="company profile" width={32} height={26} />
                      {customerData?.[0]?.vEnterprise?.name}
                    </Typography>
                    {/* <Box>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Age"
                          sx={{
                            borderColor: "#5A5F60",
                            height: "40px",
                            borderRadius: "25px",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            backgroundColor: "#03171F",
                            color: "#E2E3E3",
                            width: "216px",
                            fontWeight: "400",
                            fontSize: "14px",
                          }}
                        >
                          <MenuItem value={10}>Ten</MenuItem>
                          <MenuItem value={20}>Twenty</MenuItem>
                          <MenuItem value={30}>Thirty</MenuItem>
                        </Select>
                      </FormControl>
                    </Box> */}
                    <Button
                      sx={{
                        borderColor: "#0B4A62",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        color: "#0699CE",
                        fontSize: "14px",
                        fontWeight: "500",
                        borderRadius: "25px",
                        padding: "2px 15px",
                        textTransform: "capitalize",
                        marginLeft: "auto",
                      }}
                      onClick={() => handleAddSiteModalOpen(customerData?.[0]?.vEnterprise, "new")}
                    >
                      {" "}
                      + Add Site
                    </Button>
                  </Grid>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                    }}
                  >
                    <CardContent
                      sx={{
                        backgroundColor: "#1e222b",
                        width: "30%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          border: "0",
                          borderStyle: "solid",
                          borderBottomWidth: "1px ",
                          borderColor: "#5A5F60",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingBottom: "7px",
                          marginBottom: "7px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#E2E3E3",
                            fontSize: "16px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gridGap: "8px",
                          }}
                        >
                          <img src={sitesIcon} alt="" width={20} height={20} />
                          Sites / Devices
                        </Typography>
                        <Typography
                          variant="h4"
                          sx={{
                            color: "#E2E3E3",
                            width: "33px",
                            height: "33px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "500",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#293236",
                            display: "flex",
                          }}
                        >
                          {(customerData?.[0]?.siteCount?.active ?? 0) +
                            (customerData?.[0]?.siteCount?.suspended ?? 0)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "#B4B7B8", fontSize: "13px" }}
                        >
                          <span className="green"></span> Active :{" "}
                          {customerData?.[0]?.siteCount?.active} |{" "}
                          <span className="yellow"></span>Suspended :{" "}
                          {customerData?.[0]?.siteCount?.suspended}
                        </Typography>
                      </Box>
                    </CardContent>

                    <CardContent
                      sx={{
                        backgroundColor: "#1e222b",
                        width: "40%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          border: "0",
                          borderStyle: "solid",
                          borderBottomWidth: "1px ",
                          borderColor: "#5A5F60",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingBottom: "7px",
                          marginBottom: "7px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#E2E3E3",
                            fontSize: "16px",
                            fontWeight: "500",
                            margin: "0",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            gridGap: "8px",
                          }}
                        >
                          {" "}
                          <img
                            src={userIcon}
                            alt=""
                            width={20}
                            height={20}
                          />{" "}
                          Total Site Admins
                        </Typography>
                        <Typography
                          variant="h4"
                          sx={{
                            color: "#E2E3E3",
                            width: "33px",
                            height: "33px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "500",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#293236",
                            display: "flex",
                          }}
                        >
                          {(customerData?.[0]?.userCount?.active ?? 0) +
                            (customerData?.[0]?.userCount?.suspended ?? 0)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "#B4B7B8", fontSize: "13px" }}
                        >
                          <span className="green"></span> Active :{" "}
                          {customerData?.[0]?.userCount?.active ?? 0} |{" "}
                          <span className="yellow"></span> Suspended :{" "}
                          {customerData?.[0]?.userCount?.suspended}
                        </Typography>
                      </Box>
                    </CardContent>

                    <CardContent
                      sx={{
                        backgroundColor: "#1e222b",
                        width: "30%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          border: "0",
                          borderStyle: "solid",
                          borderBottomWidth: "1px ",
                          borderColor: "#5A5F60",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingBottom: "7px",
                          marginBottom: "7px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          sx={{
                            color: "#E2E3E3",
                            fontSize: "16px",
                            fontWeight: "500",
                            display: "flex",
                            alignItems: "center",
                            gridGap: "8px",
                          }}
                        >
                          {" "}
                          <img
                            src={licensesIcon}
                            alt=""
                            width={20}
                            height={20}
                          />{" "}
                          Total Licenses
                        </Typography>
                        <Typography
                          variant="h4"
                          sx={{
                            color: "#E2E3E3",
                            width: "33px",
                            height: "33px",
                            borderRadius: "50%",
                            fontSize: "14px",
                            fontWeight: "500",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#293236",
                            display: "flex",
                          }}
                        >
                          {(customerData?.[0]?.licenseCount?.total ?? 0)}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: "#B4B7B8", fontSize: "13px" }}
                        >
                          <span className="green"></span> Active : {customerData?.[0]?.licenseCount?.active} | {" "}
                          <span className="green"></span> Available : {customerData?.[0]?.licenseCount?.available} | {" "}
                          <span className="yellow"></span> Suspended : {customerData?.[0]?.licenseCount?.suspended}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Box>
                </Card>
                <Card
                  sx={{
                    backgroundColor: "#1e222b",
                    maxWidth: "263px",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <CardContent
                    sx={{
                      backgroundColor: "#1e222b",
                      width: "100%",
                    }}
                  >
                    {customerData?.[0]?.vCentralUsers?.map(
                      (i: any, index: any) => {
                        return (
                          <Box
                            sx={{
                              display: "inherit",
                              border: "0",
                              borderStyle: "solid",
                              borderBottomWidth: "1px ",
                              borderColor: "#5A5F60",
                              justifyContent: "space-between",
                              alignItems: "center",
                              paddingBottom: "7px",
                              marginBottom: "7px",
                              flexFlow: "wrap",
                            }}
                            key={index}
                          >
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#A5A8A9",
                                fontSize: "10px",
                                fontWeight: "400",
                                display: "flex",
                                alignItems: "center",
                                gridGap: "8px",
                                width: "100%",
                              }}
                            >
                              Primary Customer Admin
                              {/* <Typography sx={{ marginLeft: "auto" }}>
                                <img
                                  src={editIcon}
                                  alt=""
                                  width={20}
                                  height={20}
                                />
                              </Typography> */}
                            </Typography>
                            <Box
                              sx={{
                                color: "#E2E3E3",
                                fontSize: "16px",
                                fontWeight: "500",
                                display: "flex",
                                alignItems: "center",
                                gridGap: "8px",
                              }}
                            >
                              <Box
                                sx={{
                                  width: "40px",
                                  maxWidth: "20%",
                                  height: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center", // Center the text horizontally
                                  borderRadius: "50%",
                                  backgroundColor: "#069aca",
                                  overflow: "hidden",
                                  color: "#000000", // Text color
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {i?.name?.charAt(0)?.toUpperCase() || "?"} {/* Display the first letter or fallback to "?" */}
                              </Box>
                              <Box sx={{width: "80%", wordWrap: "break-word"}}>
                                {i?.name}
                                <Typography
                                  sx={{
                                    color: "#B4B7B8",
                                    fontSize: "12px",
                                    fontWeight: "400",
                                  }}
                                >
                                  {i?.mailId}
                                </Typography>
                              </Box>

                            </Box>
                          </Box>
                        );
                      }
                    )}

                    {/* <Box
											sx={{
												display: "flex",
												border: '0',
												borderStyle: 'solid',
												borderBottomWidth: '0px ',
												borderColor: '#5A5F60',
												justifyContent: 'space-between',
												alignItems: 'center',
												paddingBottom: '0px',
												marginBottom: '0px',
												flexFlow:'wrap',
											}}
										>
											<Typography variant="h6"
												sx={{
													color: '#A5A8A9',
													fontSize: '10px',
													fontWeight: '400',
													display: 'flex',
													alignItems: 'center',
													gridGap: '8px',
													width: '100%',
												}}
											>
												Primary Customer Admin
												<Typography sx={{ marginLeft: 'auto' }}>
												    <img src={editIcon}
													alt="" width={20}
													 height={20}
													/>
												</Typography>

											</Typography>
											<Typography variant="h6"
												sx={{
													color: '#E2E3E3',
													fontSize: '16px',
													fontWeight: '500',
													display: 'flex',
													alignItems: 'center',
													gridGap: '8px',
												}}
											>
												<Box
													sx={{
														width: '40px',
														height: '40px',
														display: 'flex',
														alignItems: 'center',
														borderRadius: '50%',
														backgroundColor: '#F5F5F5',
														overflow: 'hidden',
													}}
												>
												 <img src={ProfileIn} alt="" width={40} height={40} />
												</Box>
												<Box>
												Jeremiah
													<Typography
													sx={{
														color: '#B4B7B8',
														fontSize: '12px',
														fontWeight: '400',
													}}

													>richard@walmart.com</Typography>
												</Box>


											</Typography>
										</Box> */}
                  </CardContent>
                </Card>
              </Grid>

              <TabContext value={String(activeTab)}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="inherit"
                  sx={{
                    display: "flex",
                  }}
                >
                  <Tab
                    label="Licenses"
                    value={0}
                    sx={{
                      width: "210px",
                    }}
                  />
                  <Tab
                    label="Sites / Devices"
                    value={1}
                    sx={{
                      width: "210px",
                    }}
                  />
                </Tabs>

                <TabPanel value="0">
                  <CustomerLicenseTab data={customerTable} />
                </TabPanel>

                <TabPanel value="1">
                  <CustomerSitesDevicesTab data={customerTable} />
                </TabPanel>
              </TabContext>

              {/*
							<Grid container spacing={2} mb={5} mt={5}>
								<Grid size={{ xs: 12, md: 6 }}>
									<TextField
										fullWidth
										placeholder="Search by customer name or address"
										variant="outlined"
										className="searchBox"
										sx={{
											backgroundColor: "#1e222b",
											input: { color: "#ffffff" },
											borderRadius: '30px',
											border: '1px solid #5A5F60',
											padding: '0 5px !important',
											height: '41px',
											fontWeight: 'normal',
										}}
									/>
								</Grid>
							</Grid> */}

              {/* Table Section */}
              {/* <Table sx={{ backgroundColor: "#03171f", border: '1px solid #313838' }}>
								<TableHead>
									<TableRow>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>No.</TableCell>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>License Item(SKU)</TableCell>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Quantity</TableCell>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Issue Date</TableCell>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>Expiry Date</TableCell>
										<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', }}>License Key</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{data.licenses.map((license) => (
										<TableRow key={license.id} sx={{ padding: '0', margin: '0', }}>
											<TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', }}>{license.id}</TableCell>
											<TableCell colSpan={7} sx={{ padding: '0', borderColor: '#313838', margin: '0', }}>
												<Accordion sx={{ backgroundColor: "#03171f", fontSize: '14px', color: "#ffffff", padding: '0', margin: '0', }}>
													<AccordionSummary sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0 !important', margin: '0 !important' }}>
														<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>{license.name}</Typography>
														<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>{license.quantity}</Typography>
														<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>{license.issue_date}</Typography>
														<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>{license.expiry_date}</Typography>
														<Typography sx={{ color: '#B4B7B8', fontSize: '14px', borderColor: '#313838', padding: '0', margin: '0', }}>{license.license_key}</Typography>
													</AccordionSummary>
												</Accordion>
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table> */}
            </Box>
          </Typography>
        </Box>

      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="edit-site-modal"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(4px)", // For backdrop blur effect
        }}
      >
        <Box
          sx={{
            backgroundColor: "background.paper",
            borderRadius: 2,
            padding: 4,
            width: "60%",
            boxShadow: 24,
          }}
        >
          {/* Header */}
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6" id="edit-site-modal">
              Edit Site / Device Info
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Form */}
          <Grid container spacing={2}>
            {/* Site Name and Email */}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Site Name"
                required
                placeholder="Enter Customer Name"
                helperText="Unique name required"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Email ID"
                required
                placeholder="Enter Email ID"
              />
            </Grid>

            {/* Address Line 1 and 2 */}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Address Line 1"
                placeholder="Street address / company name / c/o"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Address Line 2"
                placeholder="Apartment / unit / building"
              />
            </Grid>

            {/* Postal Code, City, State, and Country */}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Postal Code"
                placeholder="Enter Postal Code"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <InputLabel>City</InputLabel>
                <Select defaultValue="Alabama">
                  <MenuItem value="Alabama">Alabama</MenuItem>
                  <MenuItem value="OtherCity">Other City</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <InputLabel>State</InputLabel>
                <Select defaultValue="Alabaster">
                  <MenuItem value="Alabaster">Alabaster</MenuItem>
                  <MenuItem value="OtherState">Other State</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <FormControl fullWidth>
                <InputLabel>Country</InputLabel>
                <Select defaultValue="United States">
                  <MenuItem value="United States">United States</MenuItem>
                  <MenuItem value="OtherCountry">Other Country</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Phone Number and Mobile Number */}
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Phone Number"
                placeholder="Enter Phone Number"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                fullWidth
                label="Mobile Number"
                placeholder="Enter Mobile Number"
              />
            </Grid>
          </Grid>

          {/* Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
            }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" color="primary">
              Save Changes
            </Button>
          </Box>
        </Box>
      </Modal>

      {addSiteModalOpen &&
        <Modal
          open={addSiteModalOpen}
          onClose={handleAddSiteModalClose}
          className="AddFeatureM"
        >
          <Box sx={{
            maxWidth: '736px',
            width: '100%',
            margin: '64px auto 0',
            padding: '24px',
            borderRadius: '30px',
            borderColor: '#5A5F60 !important',
            border: '1px solid',

          }}
          >
            <Typography variant="h6" component="h2" gutterBottom
              sx={{
                fontSize: '20px',
                color: '#E2E3E3',
                borderBottom: '1px solid #5A5F60',
                paddingBottom: '10px',
                marginBottom: '30px',
              }}
            >
              {!siteEdit ? "Add New Site / Device" : "Edit Site / Device Info"}
              <span onClick={handleAddSiteModalClose}><CloseIcon style={{ float: "right", cursor: "pointer" }}></CloseIcon></span>
            </Typography>

            <Formik
              initialValues={siteInitialValues}
              enableReinitialize={true} // Enable reinitialization
              validationSchema={object({
                enterpriseid: string().trim().required("Enterpriseid is required!"),
                name: string().trim().required("Site name / device is required!"),
                uniqueid: string().trim().required("Unique ID is required!"),
                email: string().email().required("Email ID is required!"),
                type: string().required("Type is required!"),
                addressline1: string().trim().optional(),
                addressline2: string().trim().optional(),
                postalcode: string().trim().optional(),
                city: string().nullable().optional(),
                state: string().nullable().optional(),
                country: string().nullable().optional(),
                number: string().min(2, "Must be at least 2 digits").max(10, "Cannot be more than 10 digits").optional(),
                mobile: string().trim().optional(),
                timezone: string().required("Timezone is required!"),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                let temp_values: any = { ...values };
                temp_values.country = country;
                temp_values.state = state;
                temp_values.city = city;
                if (temp_values.mobile != "" && !temp_values.mobile.includes("+")) {
									temp_values = { ...temp_values, mobile: `+${temp_values.mobile}` }
								}

                let api_endpoint = "";
                let resp;
                                
                if (!siteEdit) {
                  temp_values.redirectUrl = "/auth/set-password?uk=";
                  api_endpoint = `customer/site`;
                  resp = await postMethodFormData(api_endpoint, temp_values);
                } else {
                  api_endpoint = `customer/site/${siteId}`;
                  resp = await putFormMethod(api_endpoint, temp_values);
                }

                if (resp?.status === 200) {
                  fetchCustomerList();
                  setToast(resp?.data?.message, "success");
                  setCustomerTimeZone("");
                  setAddSiteModalOpen(false);
                } else if (resp?.status === 400) {
                  setToast(resp?.data?.message, "error");
                }
              }}
            >
              {({ values, isSubmitting, setFieldValue, errors, touched }) => (
                <Form>
                  <Grid container spacing={2} className="customer_popup" style={{ paddingBottom: "30px" }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Site / Device Name<span style={{ color: "red" }}>*</span></Typography>
                        <Field
                          name="name"
                          as="input"
                          type="text"
                          component={formikTextField}
                          className="inputC"
                          placeholder="Enter Site / Sevice Name"
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Unique ID<span style={{ color: "red" }}>*</span></Typography>
                        <Field
                          name="uniqueid"
                          as="input"
                          type="text"
                          component={formikTextField}
                          className="inputC"
                          placeholder="Enter Unique ID"
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Type<span style={{ color: "red" }}>*</span></Typography>
                        <Field
                          name="type"
                          as="select"
                          placeholder="type"
                          className="inputC custDropdown"
                        >
                          <option value="EDGE">EDGE</option>
                          <option value="CLOUD">CLOUD</option>
                        </Field>
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Email ID<span style={{ color: "red" }}>*</span></Typography>
                        <Field
                          name="email"
                          type="text"
                          component={formikTextField}
                          className="inputC"
                          placeholder="Enter Email ID"
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Address Line 1</Typography>
                        <Field
                          name="addressline1"
                          as="input"
                          type="text"
                          component={formikTextField}
                          className="inputC"
                          placeholder="Street address / company name / c/o"
                        />

                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12 }}>
                      <RBFORM.Group>
                        <Typography variant="subtitle1"
                          sx={{
                            color: '#B4B7B8',
                            fontSize: '14px',
                          }}
                        > Address Line 2</Typography>
                        <Field
                          name="addressline2"
                          as="input"
                          type="text"
                          component={formikTextField}
                          className="inputC"
                          placeholder="Apartment / unit / building"
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">Country</RBFORM.Label>
                        <Field
                          name="country"
                          as="select"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                        >
                          {countryList?.length > 0 ? (
                            countryList.map((country: any) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))
                          ) : (
                            <option>Select Country</option>
                          )}
                        </Field>
                      </RBFORM.Group>
                    </Grid>


                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">State</RBFORM.Label>
                        <Field
                          name="state"
                          as="select"
                          placeholder="State"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleStateChange(e, setFieldValue)}
                        >
                          {filteredStateList?.length > 0 ? (
                            filteredStateList.map((state: any) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))
                          ) : (
                            <option>Select State</option>
                          )}
                        </Field>
                      </RBFORM.Group>
                    </Grid>


                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">City</RBFORM.Label>
                        <Field
                          name="city"
                          as="select"
                          placeholder="City"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleCityChange(e, setFieldValue)}
                        >
                          {filteredCityList?.length > 0 ? (
                            filteredCityList.map((city: any) => (
                              <option key={city.id} value={city.id}>
                                {city.name}
                              </option>
                            ))
                          ) : (
                            <option>Select City</option>
                          )}
                        </Field>
                      </RBFORM.Group>
                    </Grid>


                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                        <Field
                          name="postalcode"
                          type="text"
                          placeholder="Enter Postal Code"
                          component={formikTextField}
                          className="inputC"
                        />
                      </RBFORM.Group>
                    </Grid>


                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                        <Field
                          name="number"
                          type="text"
                          placeholder="Enter Phone Number"
                          component={formikTextField}
                          className="inputC"
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                        <PhoneInput
                          country={'us'}
                          specialLabel=""
                          dropdownClass="user-phone-input-dropdown"
                          containerClass="user-phone-input-container"
                          inputClass={`${errors.mobile ? "errors" : ""} modalForm-input user-phone-input`}
                          inputStyle={{
                            boxShadow: 'none',
                            color: "#A5A8A9",
                            border: "1px solid #313838 !important",
                            width: "100%",
                            height: "40px",
                            backgroundColor: "#192529",
                          }}
                          value={values.mobile}
                          onChange={(number) => setFieldValue("mobile", number)}
                        />
                      </RBFORM.Group>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                      <RBFORM.Group>
                        <RBFORM.Label className="label">Timezone</RBFORM.Label>
                        <Field
                          name="timezone"
                          as="select"
                          className="inputC custDropdown"
                          onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                          style={{ cursor: "pointer" }}
                        >
                          <option disabled>Select</option>
                          {timezoneList.map((tz) => (
                            <option key={tz.value} value={tz.value}>
                              {tz.label}
                            </option>
                          ))}

                        </Field>
                      </RBFORM.Group>
                    </Grid>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>
                        <img src={noteIcon} style={{ width: "20px", height: "20px" }} />
                      </span>
                      <span
                        className="label"
                        style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
                      >
                        Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
                      </span>
                    </div>
                  </Grid>

                  <Field
                    name="enterpriseid"
                    type="hidden"
                    placeholder="Enter Phone Number"
                    component={formikTextField}
                    className="inputC"
                    style={{ display: "none" }}
                    value={id}
                  />

                  {/* <input type="text" name="enterpriseid" value={customerEnterpriseId} /> */}
                  {/* {JSON.stringify(values, null, 2)} */}



                  <Box sx={{ display: "flex", borderTop: "1px solid #5A5F60", paddingTop: '20px', justifyContent: "flex-end", gap: 2 }}>
                    <Button type="button" onClick={handleAddSiteModalClose} variant="outlined"
                      sx={{ color: '#0699CE', textTransform: 'capitalize', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={isSubmitting}
                      sx={{
                        color: '#1F2F34', height: '41px', lineHeight: '41px',
                        borderColor: '#0B4A62', background: '#17B2EB',
                        borderRadius: '25px', fontSize: '14px',
                        fontWidth: '500',
                        textTransform: 'capitalize',
                      }}
                    >
                      Save Changes
                    </Button>
                  </Box>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>
      }

    </>
  );
};

export default CustomerDetails;
